module.exports = __webpack_public_path__ + "login-logo.png?090daefa2ee6b950027c531fc9aecf62";